@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'revisions.detail'">
    <div class="deviceTitle xs12col padding-bottom-large">
      @if (('Permissions.Devices.Create' | permission)) {
        <button
          kendoButton
          [routerLink]="['/devices-admin/new']"
          [hidden]="revisionStatus?.isFinalStatus == true"
          [queryParams]="{ companyId: vm.selectedRevision?.company?.id, revisionId: vm.selectedRevision?.id}"
          class="addIcon small">
          <span class="icon">
            <img src="../../../assets/icons/add-icon.svg">
          </span>
          <span>{{t('add')}}</span>
        </button>
      }
    </div>
    <div class="xs12col flexColumn padding-right-medium" [hidden]="revisionStatus?.isFinalStatus == true">
      <h2 class="padding-bottom-medium">{{ t('searchDevices') }}</h2>
      <form
        [formGroup]="filterForm"
        (ngSubmit)="onSubmit(vm.searchRequest)"
        class="searchForm">
        <kendo-formfield class="xs12col m6col">
          <kendo-label [text]="t('installation')"></kendo-label>
          <kendo-dropdownlist
            [data]="vm.installations?.data"
            textField="name"
            valueField="id"
            [defaultItem]="{ id: null, name: t('chooseInstallation') }"
            formControlName="installationId"
            [valuePrimitive]="true">
          </kendo-dropdownlist>
        </kendo-formfield>
        <kendo-formfield class="xs12col m6col">
          <kendo-label [text]="t('deviceCategory')"></kendo-label>
          <kendo-dropdownlist
            [data]="vm.deviceCategories"
            textField="name"
            valueField="id"
            [defaultItem]="{ id: null, name: t('chooseDeviceCategory'), hasSerialNumber: null }"
            formControlName="deviceCategoryId"
            [valuePrimitive]="true">
          </kendo-dropdownlist>
        </kendo-formfield>
        <kendo-daterange class="xs12col m6col">
          <kendo-label [text]="t('executionDate')"  class="label"></kendo-label>
          <kendo-dateinput
            kendoDateRangeStartInput
            formControlName="executionDateFrom"
            [placeholder]="t('placeholderFrom')"
          ></kendo-dateinput>
          <kendo-dateinput
            kendoDateRangeEndInput
            formControlName="executionDateTo"
            [placeholder]="t('placeholderTo')"
          ></kendo-dateinput>
        </kendo-daterange>
        <kendo-formfield class="xs12col m6col">
          <div class="searchInputContainer">
            <span  class="tooltipContainer">
              <kendo-label [text]="t('keyword')"></kendo-label>
              <span [attr.tooltip]="t('tooltipSearch')" flow="right" class="tooltipContainer">
                <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
              </span>
            </span>
            <kendo-textbox
              formControlName="keyword" class="searchTextField">
            </kendo-textbox>
          </div>
        </kendo-formfield>
        <div class="buttonContainer margin-bottom-large flex-wrap">
          <button
            [disabled]="filterForm.invalid || filterForm.pristine"
            type="submit"
            kendoButton
            class="buttonPrimary">
            {{t('filterSearch')}}
          </button>
          <button
            type="button"
            (click)="resetFilter()"
            class="buttonSecondary">
            {{ t('resetFilter') }}
          </button>
        </div>
      </form>
      <kendo-grid
        [data]="{data: vm.availableDevicesForRevision, total: vm.total}"
        [skip]="vm.gridState.skip"
        [pageSize]="vm.gridState.pageSize"
        [pageable]="true"
        (pageChange)="pageChangeSub$.next($event)">
        <!-- DESKTOP GRID -->
        <kendo-grid-column field="deviceManufacturerId" [title]="t('device.manufacturer')" media="(min-width: 993px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.manufacturer?.name}}
          </ng-template>
          <ng-template let-formGroup="formGroup">
            <kendo-textbox [formControl]="formGroup.get('deviceManufacturerId')"></kendo-textbox>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="tagNumber" [title]="t('device.tagNumber')" media="(min-width: 993px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.tagNumber}}
          </ng-template>
          <ng-template let-formGroup="formGroup">
            <kendo-textbox [formControl]="formGroup.get('tagNumber')"></kendo-textbox>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="serialNumber" [title]="t('device.serialNumber')" media="(min-width: 993px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.serialNumber}}
          </ng-template>
          <ng-template let-formGroup="formGroup">
            <kendo-textbox [formControl]="formGroup.get('serialNumber')"></kendo-textbox>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="type" [title]="t('device.type')" media="(min-width: 993px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.type}}
          </ng-template>
          <ng-template let-formGroup="formGroup">
            <kendo-textbox [formControl]="formGroup.get('type')"></kendo-textbox>
          </ng-template>
        </kendo-grid-column>
        <!-- MOBILE GRID -->
        <kendo-grid-column media="(max-width: 992px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <h4 class="mobileGridHeader">{{t('device.manufacturer')}}</h4>
            <span>{{dataItem.manufacturer?.name}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(max-width: 992px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <h4 class="mobileGridHeader">{{t('device.tagNumber')}}</h4>
            <span>{{dataItem.tagNumber}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(max-width: 992px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <h4 class="mobileGridHeader">{{t('device.serialNumber')}}</h4>
            <span>{{dataItem.serialNumber}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(max-width: 992px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <h4 class="mobileGridHeader">{{t('device.type')}}</h4>
            <span>{{dataItem.type}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column>
          <ng-template kendoGridCellTemplate let-dataItem>
            <button
              kendoButton
              class="addIcon small"
              [hidden]="!('Permissions.Revisions.Update' | permission)"
              loadingIndication="revisions/addDeviceToRevision/"
              [disabled]="revisionStatus == 20"
              (click)="linkDevice(dataItem.id)">
              <span class="icon">
                <img src="../../../assets/icons/add-icon.svg">
              </span>
            </button>
          </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridNoRecordsTemplate>
          <div class="text pl">{{t('noResults')}}</div>
        </ng-template>
        <ng-template kendoGridLoadingTemplate>
          <div class="k-loading-color"></div>
          <div class="loading-container">
            <kendo-loader type="converging-spinner" size="large"></kendo-loader>
          </div>
        </ng-template>
        <!-- Paging -->
        <ng-template
          let-totalPages="totalPages"
          let-currentPage="currentPage"
          kendoPagerTemplate
          >
          <div class="width100 flex -spaceAround -alignCenter mts">
            <div class="flex">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons
                [buttonCount]="5"
              ></kendo-pager-numeric-buttons>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
            <div class="flex -alignCenter">
              <kendo-buttongroup
                [selection]="'single'"
                id="pageBtnGroup"
                class="-purple"
                >
                <button
                            (click)="
                            pageChangeSub$.next({
                                skip: 0,
                                take: pageSizes.Small
                            })
                            "
                  kendoButton
                  [selected]="vm.gridState.pageSize === pageSizes.Small"
                  [toggleable]="true"
                  >
                  {{ pageSizes.Small }}
                </button>
                <button
                            (click)="
                            pageChangeSub$.next({
                                skip: 0,
                                take: pageSizes.Medium
                            })
                            "
                  kendoButton
                  [selected]="vm.gridState.pageSize === pageSizes.Medium"
                  [toggleable]="true"
                  >
                  {{ pageSizes.Medium }}
                </button>
                <button
                            (click)="
                            pageChangeSub$.next({
                                skip: 0,
                                take: pageSizes.Large
                            })
                            "
                  kendoButton
                  [selected]="vm.gridState.pageSize === pageSizes.Large"
                  [toggleable]="true"
                  >
                  {{ pageSizes.Large }}
                </button>
              </kendo-buttongroup>
            </div>
          </div>
        </ng-template>
      </kendo-grid>
    </div>
  </ng-container>
}